import { createRequest } from '@shared/services';

interface GetLayoutPropType {
    section?: string;
    pageId?: string;
    layoutId?: string;
}

interface GetLayoutByIdPropType {
    layoutId: string;
    section?: string;
    pageId?: string;
}

interface PostLayoutPropType {
    section: string;
    pageId: string | null;
    layout: unknown;
}

interface PutLayoutPropType extends PostLayoutPropType {
    layoutId: string;
}

interface DeleteLayoutPropType {
    layoutId: string;
}

type DeleteLayoutReturn = BasicAPIResponse<{
    success: boolean;
}>;

export async function getLayout({
    section,
    pageId: page_id,
    layoutId: layout_id,
}: GetLayoutPropType) {
    const request = createRequest<LayoutResponse>({
        url: '/layout',
        method: 'GET',
        withAuthorization: true,
        useToastHandler: false,
        params: {
            section,
            page_id,
            layout_id,
        },
    });

    return request.execute();
}

export async function getLayoutById({
    layoutId: layout_id,
    pageId: page_id,
    section,
}: GetLayoutByIdPropType) {
    const request = createRequest<LayoutResponse>({
        url: `/layout/${layout_id}`,
        method: 'GET',
        withAuthorization: true,
        useToastHandler: false,
        params: {
            section,
            page_id,
        },
    });

    return request.execute();
}

export async function postLayout({
    section,
    pageId: page_id,
    layout,
}: PostLayoutPropType) {
    const request = createRequest<LayoutResponse>({
        url: '/layout',
        method: 'POST',
        withAuthorization: true,
        data: {
            section,
            page_id,
            layout,
        },
    });

    return request.execute();
}

export async function putLayout({
    layoutId: layout_id,
    layout,
    pageId: page_id,
    section,
}: PutLayoutPropType) {
    const request = createRequest<LayoutResponse>({
        url: `/layout/${layout_id}`,
        method: 'PUT',
        withAuthorization: true,
        data: {
            section,
            page_id,
            layout,
        },
    });

    return request.execute();
}

export async function deleteLayout({ layoutId: layout_id }: DeleteLayoutPropType) {
    const request = createRequest<DeleteLayoutReturn>({
        url: `/layout/${layout_id}`,
        method: 'DELETE',
        withAuthorization: true,
        useToastHandler: false,
    });

    return request.execute();
}
